import React from "react";
import Tippy from "@tippyjs/react/headless";
import Icon from "~/common/Icons/Standard";
import Arrow from "~/common/PopupArrow";

const HelpIcon = () => {
  return (
    <Tippy
      placement="bottom"
      hideOnClick={false}
      render={(attrs) => (
        <div className="relative left-5px">
          <div
            className="bg-clip-padding bg-white border-black-200 rounded-md border-solid border hidden max-w-full p-px whitespace-normal w-48-1/2 shadow-black-200 xs:block"
            {...attrs}
          >
            <header className="bg-gray-50 border-gray-200 border-solid border-0 border-b m-0 py-2 px-3-1/2">
              <h3 className="text-shadow-white font-semibold text-sm-3/4 leading-4-1/8 m-0 text-gray-800">
                SMS Text Messages
              </h3>
            </header>
            <div className="px-3-1/2 py-2-1/4">
              <p className="text-sm-1/2 leading-4-1/8 mb-0">
                Phone number must be able to receive text messages
              </p>
              <p className="text-2xs leading-loose mb-0">
                Message and data rates may apply. You may opt-out at any time by
                sending STOP to +17172887303. (Note: if you texted STOP but
                would like to restart, text START, and make sure your number
                below is correct.)
              </p>
              {attrs["data-placement"] && (
                <Arrow placement={attrs["data-placement"]} />
              )}
            </div>
          </div>
        </div>
      )}
    >
      <button
        type="button"
        className="bg-transparent border-0 p-0 text-green-500 no-underline"
      >
        <Icon
          name="question"
          data-testid="question-icon"
          height="0.8rem"
          width="0.85rem"
          className="inline-block fill-current text-green-500"
        />
      </button>
    </Tippy>
  );
};

export default HelpIcon;
